import { FC, useCallback } from "react";
import { FaWind } from "react-icons/fa";
import useFetch from "../../../hooks/useFetch";
import { ParkService } from "../../../services/park/parkService";
import { LuClipboardList } from "react-icons/lu";

interface speciesCardProps {   
    data: any;
}

const SpeciesCard:FC<speciesCardProps> = ({ data }) => {


    // RENDER 

    return (
        <div className="bg-white dark:bg-gray-800 shadow-lg rounded-lg p-4">
            <div className="flex items-start justify-between">
                <div className="flex flex-col">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Especies</h2>
                    <p className="text-sm text-gray-400 dark:text-gray-300">Especies registradas en la aplicación</p>  
                </div>
                <LuClipboardList className="mt-1 text-primary" />
            </div>

            <div className="flex items-center justify-start mt-4">
                <h2 className="text-3xl font-semibold text-gray-800 dark:text-white">{data ? data : '0'}</h2>
            </div>
        </div>
    );
}

export default SpeciesCard;